import React from 'react'
import './AccountDeleteStepSales.css'

const AccountDeleteStepSales = () => {
  return (
    <div className="account-delete-container">
      <h2 className="account-delete-title">How to Delete My Account</h2>
      <p>
        Deleting the account will result in your mobile number, email address, and profile name being deleted from the platform and makes all other attributes related to your Optigo Sales account anonymous so it is no longer associated with your phone number.
      </p>
      <p>
        If you want to delete your account from the Optigo Sales platform, please follow the steps below:
      </p>
      <h3>iOS / Android App:</h3>
      <ul>
        <li>Log in to your Optigo Sales account</li>
        <li>Go To ‘settings’ on Top right Corner (customer select page/below profile )</li>
        <li>Select ‘Delete My Account’</li>
        <li>Click on ‘Yes to Delete Account’</li>
        <li>Your account deletion will be completed in a maximum of 30 days</li>
      </ul>
      <h3>Website:</h3>
      <ul>
        <li>Log in to your Optigo Sales App account with your company code ,user id, password, personal qr</li>
        <li>Contact us via available options at the bottom of this page and submit your request</li>
      </ul>
      <h3>Things to Note Before Deleting Your Account:</h3>
      <ul>
        <li>Account deletion will take a maximum of 30 days.</li>
        <li>Once the account is deleted, you will not be able to recover it.</li>
      </ul>
    </div>
  )
}

export default AccountDeleteStepSales